//
//
//
//

import displayLoggerAttributesQuery from '~/apollo/queries/product/display-logger-attributes'

export default {
  props: {
    productId: String
  },
  apollo: {
    displayLoggerAttributes: {
      prefetch: true,
      query: displayLoggerAttributesQuery,
      variables () {
        return { documentId: this.productId }
      }
    }
  }
}
